/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  H3,
  IconArrowHead,
  InlineTextButton,
  Modal,
  SearchBar,
  SecondaryButton,
} from '../../../components';
import { FormattedMessage } from 'react-intl';
import SecondaryFilters from '../SecondaryFilters/SecondaryFilters';
import SearchFilterPills from '../SearchFilterPills/SearchFilterPills';
import IconFilter from '../../../components/IconFilter/IconFilter';

import css from './SearchFilters.module.css';
import classNames from 'classnames';

const MODAL_BREAKPOINT = 768; // Search is in modal on mobile layout

const SearchFilters = props => {
  const {
    renderPriceComponent,
    onManageDisableScrolling,
    sortByComponent,
    handleResetAllFilters,
    resultsCount,
  } = props;
  const [mobileFiltersOpened, setMobileFiltersOpened] = useState(false);

  const resetAllButton = (
    <button className={css.resetAllButton} onClick={handleResetAllFilters}>
      <FormattedMessage id={'SearchFiltersPills.resetAll'} />
    </button>
  );

  return (
    <div className={css.root}>
      <SearchBar
        className={css.searchbarRoot}
        inputClassName={css.searchbar}
        buttonClassName={css.searchbarButton}
        buttonContent={
          <span>
            <FormattedMessage id="Global.search" />
          </span>
        }
      />

      <div className={classNames(css.filtersWrapper, css.desktopOnly)}>
        <SecondaryFilters renderPriceComponent={renderPriceComponent} />
      </div>
      <Modal
        contentClassName={css.modal}
        id="SearchPage_mobileFilters"
        isOpen={mobileFiltersOpened}
        onClose={() => setMobileFiltersOpened(false)}
        showAsModalMaxWidth={MODAL_BREAKPOINT}
        onManageDisableScrolling={onManageDisableScrolling}
        noCloseButton
        containerClassName={css.modalContainer}
      >
        <div className={css.filtersMobile}>
          <div className={css.header}>
            <InlineTextButton
              onClick={() => setMobileFiltersOpened(false)}
              className={css.closeButton}
            >
              <IconArrowHead direction="left" />
              <FormattedMessage id="CloseListingModal.close" />
            </InlineTextButton>
            <H3>
              <FormattedMessage id="General.filters" />
            </H3>
            <button className={css.resetAllButton} onClick={handleResetAllFilters}>
              <FormattedMessage id={'SearchFiltersMobile.resetAll'} />
            </button>
          </div>
          <div className={css.modalBody}>
            {mobileFiltersOpened && (
              <div className={classNames(css.filtersWrapper)}>
                <SecondaryFilters renderPriceComponent={renderPriceComponent} />
              </div>
            )}
          </div>
          <div className={css.footer}>
            <SecondaryButton
              className={css.applyButton}
              onClick={() => setMobileFiltersOpened(false)}
            >
              <FormattedMessage
                id="SearchFiltersMobile.showListings"
                values={{ count: resultsCount }}
              />
            </SecondaryButton>
          </div>
        </div>
      </Modal>

      <SearchFilterPills resetAllButton={resetAllButton} />
      <div className={css.buttonsWrapper}>
        <button
          className={classNames(css.filtersButtonMobile, css.sortByMenuLabel)}
          onClick={() => setMobileFiltersOpened(true)}
        >
          <IconFilter /> <FormattedMessage id="SearchFilters.filtersHeading" />
        </button>
        <div className={css.sortByWrapper}>{sortByComponent}</div>
      </div>
    </div>
  );
};

export default SearchFilters;
